import axios from 'axios'
import router from '../router'
import { Message} from 'element-ui'
import { getDesKey } from "./security"

let instance = axios.create({
  transformRequest: [function transformRequest(data, headers) {
      normalizeHeaderName(headers, 'Content-Type');
      if (utils.isFormData(data) ||
        utils.isArrayBuffer(data) ||
        utils.isBuffer(data) ||
        utils.isStream(data) ||
        utils.isFile(data) ||
        utils.isBlob(data)
      ) {
        return data;
      }
      if (utils.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils.isURLSearchParams(data)) {
        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8')
        return data.toString()
      }
      /*改了这里*/
      if (utils.isObject(data)) {
        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8')
        let _data = Object.keys(data)
        return encodeURI(_data.map(name => `${name}=${data[name]}`).join('&'))
      }
      return data
  }]
})

export const MEDIA_URL = 'http://mdm.jh:80';

export const alertMessage = (msg) => {
  Message.warning(msg);
}

export const SysMessage = (msg) => {
  Message.warning(msg);
}

axios.interceptors.request.use(config=> {
  return config;
}, err=> {
  alertMessage('请求超时!')

  return Promise.resolve(err);
})

axios.interceptors.response.use(data=> {
  return data
}, err=> {
  // 处理HTTP的错误
  if (err.response.status == 500) {
    alertMessage('服务器内部错误！\n 错误信息：' + err.response.data.message);
  } else if (err.response.status == 401) {
    if (err.response.data.code) {
      if (err.response.data.code == 'YBLB00020014') {
        alertMessage('您登录的用户账号不存在，请修改后再次登录！')
      } else if(err.response.data.code == '1239'){
        alertMessage('登录密码输入有误，请重试!')
      } else {
        alertMessage('您未登录系统，错误信息：' + err.response.data.message)
      }
    } else {
      alertMessage('您未登录系统，错误信息：' + err.response.data.message)
    }
    router.push({ name: 'login'})
  } else if (err.response.status == 403) {
    alertMessage('您没有请求资源的访问权限，请联系管理员或者换角色重新登录！')
    router.push({ name: 'login'});
  } else if (err.response.status == 400 || err.response.status == 404 || err.response.status == 415 || err.response.status == 405) {
    alertMessage('请求参数有错误！\n 错误信息为：' + err.response.data.message + ' 错误码：' + err.response.data.code + '\n' )
  } else if (err.response.status == 302) {
    alertMessage('请重新登录！')
    router.push({ name: 'login'});
  } else {
    alertMessage('未知错误!')
  }
  return Promise.resolve(err)
})

let base = ''
export const getDTimes = (data) => {
  var now = new Date(data);
  var yearString = now.getFullYear().toString();
  var monthString, dateString, hours, minutes,seconds;
  var month = (now.getMonth() + 1);
  var date = now.getDate();
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  monthString = month < 10 ? '0' + month : month;
  dateString = date < 10 ? '0' + date : date;
  hours = hour < 10 ? '0' + hour : hour;
  minutes = minute < 10 ? '0' + minute : minute;
  seconds = second < 10 ? '0' + second : second;
  var result = yearString + "-" + monthString + "-" + dateString + " " + hours + ':' + minutes + ":" + seconds;
  return result
}
export const getdate = (data) => {
  var now = new Date(data);
  var yearString = now.getFullYear().toString();
  var monthString, dateString;
  var month = (now.getMonth() + 1);
  var date = now.getDate();
  monthString = month < 10 ? '0' + month : month;
  dateString = date < 10 ? '0' + date : date;
  var result = yearString  + monthString  + dateString;
  return result
}

export const gettime = (data) => {
  var now = new Date(data);
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  var hours, minutes,seconds;
  hours = hour < 10 ? '0' + hour : hour;
  minutes = minute < 10 ? '0' + minute : minute;
  seconds = second < 10 ? '0' + second : second;
  var result = hours + ':' + minutes;
  return result
}

export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    headers: {
      desKey: getDesKey(),
      'content-Type': "application/json;charset=utf-8",
      "x-requested-with":"XMLHttpRequest"
    },
    params: params
  });
}

export const deleteRequest = (url,params) => {
  return axios({
    method: 'delete',
    data: params,
    headers: {
      desKey: getDesKey(),
      'content-Type': "application/x-www-form-urlencoded",
      "x-requested-with":"XMLHttpRequest"
    },
    url: `${base}${url}`
  });
}

export const postRequest = (url, data) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: data,
    headers: {
      desKey: getDesKey(),
      'content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
      "x-requested-with":"XMLHttpRequest"
    }
  });
}

export const postRequestp = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    params: params,
    headers: {
      desKey: getDesKey(),
      'content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
      "x-requested-with":"XMLHttpRequest"
    }
  });
}

export const patchRequest = (url, data) => {
  return axios({
    method: 'patch',
    url: `${base}${url}`,
    data: data,
    headers: {
      desKey: getDesKey(),
      'content-Type': "application/json;charset=utf-8",
      "x-requested-with":"XMLHttpRequest"
    }
  });
}

export const postForm = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'content-Type': "application/x-www-form-urlencoded",
      "x-requested-with":"XMLHttpRequest"
    }
  });
}
